"use client";
import Swal from "sweetalert2";

import React, { useEffect, useMemo, useState } from "react";
import BookingTable from "./common/Table";
import {
  useChangeLocalPackageStatus,
  useGetUserBookingTypeMapping,
  useLocalPackages,
} from "@/hooks/useCommon";
import { Pencil } from "lucide-react";
import Link from "next/link";
import { usePackageModeMappingStore } from "@/store/common";
import { useRouter } from "next/navigation";
type PackageModeMapping = {
  id: any;
  sno: number;
  category: string;
  country: string;
  country_id: string;
  state: string;
  state_id: string;
  city: string;
  city_id: string;
  bookingType: string;
  booking_type_id: string;
  vehicleType: string;
  vehicle_type_id: string;
  bookingMode: string;
  createdBy: string;
  status: string;
  action: string;
};
interface Column {
  key: string;
  header?: string | React.ReactNode;
  sortable?: boolean;
  filterable?: boolean;
  filterType?: any;
  render?: (value: any, row?: any) => React.ReactNode;
  hidden?: boolean;
}

export default function PackageModeMappingTable() {
  const [selectedRows, setSelectedRows] = useState<Set<number>>(new Set());

  const { mutate: bookingTypeMappingDataMutate, data: bookingTypeMapping } =
    useGetUserBookingTypeMapping();

  const { packageModeData, setPackageModeData, resetPackageModeData } =
    usePackageModeMappingStore();

  const router = useRouter();

  useEffect(() => {
    bookingTypeMappingDataMutate(packageModeData);
  }, [packageModeData]);

  useEffect(() => {
    bookingTypeMappingDataMutate({})
  },[])

  const { mutate: changeStatus } = useChangeLocalPackageStatus();

  const tableData: PackageModeMapping[] = useMemo(() => {
    if (!bookingTypeMapping) return [];
    return bookingTypeMapping.map((item: any, index: number) => ({
      sno: index + 1,
      category:
        item.mapping_category == "1"
          ? "Country"
          : item?.mapping_category == "2"
          ? "State"
          : "City",
      country: item.country_name || "-",
      state: item.state_name || "-",
      state_id: item.state_id || "-",
      city: item.city_name || "-",
      city_id: item.city_id || "-",
      bookingType: item.package_name || "-",
      packageName: item.package_name || "-",
      id: item.id || "-",
      bookingMode: item.package_mode || "-",
      bookingModeID: item.master_package_mode_id || "-",
      vehicle_type: item.vehicle_type || "",
      vehicleType: item.vehicle_type_name || "-",
      createdBy:
        `${item.created_by_first_name} ${item.created_by_last_name}` || "-",
      createdById: item.created_by || "",
      modifiedBy: item.modified_by || "",
      status: item.status == 1 ? "Active" : "Inactive",
      action: "View",
    }));
  }, [bookingTypeMapping]);

  // Toggle one row selected/unselected
  const toggleRow = (userId: number) => {
    setSelectedRows((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(userId)) {
        newSet.delete(userId);
      } else {
        newSet.add(userId);
      }
      return newSet;
    });
  };
  const toggleAll = () => {
    if (selectedRows.size === tableData.length) {
      setSelectedRows(new Set());
    } else {
      setSelectedRows(new Set(tableData.map((row) => row.id)));
    }
  };
useEffect(() => {
  console.log({bookingTypeMapping})
}, [bookingTypeMapping]);
  const editMappingData = (item: any, rowdata: any) => {
    router.push(`/add-booking-type-mapping/${rowdata.id}`);
    setPackageModeData(rowdata);
  };

  const columns: Column[] = [
    {
      key: "select",
      header: (
        <div className="flex items-center gap-2">
          <input
            type="checkbox"
            checked={
              selectedRows.size === tableData.length && tableData.length > 0
            }
            onChange={toggleAll}
            aria-label="Select All"
          />
          <span>All</span>
        </div>
      ),
      render: (_: string, row: PackageModeMapping) => (
        <input
          type="checkbox"
          checked={selectedRows.has(row.sno)}
          onChange={() => toggleRow(row.sno)}
          aria-label={`Select row ${row.sno}`}
          onClick={(e) => e.stopPropagation()}
        />
      ),
      sortable: false,
    },
    { key: "sno", header: "SNo", sortable: true },
    { key: "category", header: "Category", sortable: true },
    { key: "country", header: "Country", sortable: true },
    { key: "state", header: "State", sortable: true },
    { key: "city", header: "City", sortable: true },
    { key: "bookingType", header: "Booking Type", sortable: true },
    { key: "vehicleType", header: "Vehicle Type", sortable: true },
    { key: "bookingMode", header: "Booking Mode", sortable: true },
    { key: "createdBy", header: "Created By", sortable: true },
    {
      key: "status",
      header: "Status",
      sortable: true,
      render: (value: string, row: any) => (
        <span
          className={`w-3 h-3 rounded-full flex items-center justify-center text-center text-[10px] text-white cursor-pointer ${
            value === "Active"
              ? "bg-green-600"
              : value === "Pending"
              ? "bg-yellow-700"
              : "bg-red-500"
          }`}
          onClick={(e) => {
            e.stopPropagation();
            changeStatus({
              id: row.id,
              package_status: row.status === "Active" ? 0 : 1,
            });
          }}
        >
          {/* Optional: Show a dot or short label */}
        </span>
      ),
    },
    {
      key: "action",
      header: "Action",
      sortable: false,
      render: (item: PackageModeMapping, row: any) => {
        return (
          <div className="flex items-center gap-1 justify-center">
            <button
              type="button"
              className="text-blue-600 text-xs hover:text-blue-800 font-medium cursor-pointer"
              onClick={() => editMappingData(item, row)}
            >
              {/* <Link href={`/add-booking-type-mapping/${row.id}`}> */}
              <Pencil className="w-3 h-3" />
              {/* </Link> */}
            </button>
          </div>
        );
      },
    },
  ];
  return (
    <div className="mt-4 mx-4 gap-6 py-4">
      <BookingTable
        data={tableData}
        columns={columns.map((col) => ({
          ...col,
          header: col.header ?? col.key,
        }))}
        searchable={false}
        filterable={false}
        sortable={false}
        itemsPerPage={10}
      />
    </div>
  );
}
